import { render, staticRenderFns } from "./DisplayComments.vue?vue&type=template&id=4f6fd81b&"
import script from "./DisplayComments.vue?vue&type=script&lang=js&"
export * from "./DisplayComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports